var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-10",attrs:{"fluid":"","grid-list-xl":""}},[_c('movie-search',{on:{"search-movies":_vm.setMovies}}),_c('movie-list',{attrs:{"movies":_vm.movies}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }